import list from './list';
import details from './details';
import dialog from './dialog';

export default {
  ...list,
  ...details,
  ...dialog,
};
